import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=2284b09c&scoped=true"
import script from "./Today.vue?vue&type=script&lang=js"
export * from "./Today.vue?vue&type=script&lang=js"
import style0 from "./Today.vue?vue&type=style&index=0&id=2284b09c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284b09c",
  null
  
)

export default component.exports